// useUserDetails.ts

import { useQuery } from '@tanstack/react-query';
import { getUserDetails } from '../services/apiUsers.ts';

export function useUserDetails(userId: string | null) {
  const {
    data: userDetails,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['userDetails', userId],
    queryFn: () => (userId ? getUserDetails(userId) : null),
    enabled: !!userId,
  });

  return { userDetails, isLoading, error, refetch };
}
